export default [
  {
    path: "/futures",
    name: "merchandiser",
		redirect: '/futures/merchandiser',
		component: () => import('@/pages/merchandiser/comm.vue'),
    children: [
			{
				path: 'merchandiser',
				name: 'merchandiser', // index
				component: () => import("@/pages/v2/merchandiser/pages/index"),
			},
			{
				path: 'merchandiser/apply-trader',
				name: 'ApplyTrader', // 申请成为交易员
				component: () => import('@/pages/v2/merchandiser/pages/apply-trader')
			},
			{
				path: 'merchandiser/my-documentary',
				name: 'gendan', // 我的跟单
				component: () => import('@/pages/v2/merchandiser/pages/my-documentary')
			},
			{
				path: 'merchandiser/documentary-form',
				name: 'gendan', // 跟单
				component: () => import('@/pages/v2/merchandiser/pages/documentary-form')
			},
			{
				path: 'merchandiser/band-single',
				name: 'daidan', // 带单
				component: () => import('@/pages/v2/merchandiser/pages/band-single')
			},
			{
				path: 'merchandiser/teach-details',
				name: 'teach', // 带单老师
				component: () => import('@/pages/v2/merchandiser/pages/teach-details')
			}
		],
    meta: {
      i18n: {
        zh_CN: () => require("@/i18n/lang/merchandiser/zh.js"),
        en_US: () => require("@/i18n/lang/merchandiser/en.js"),
        ko_KR: () => require("@/i18n/lang/merchandiser/kr.js"),
        zh_TW: () => require("@/i18n/lang/merchandiser/tw.js"),
		vi_VN: () => require("@/i18n/lang/merchandiser/vi.js"),
		id_ID: () => require("@/i18n/lang/merchandiser/ba.js"),
		tr_TR: () => require("@/i18n/lang/merchandiser/tr.js"),
		ru_Ru: () => require("@/i18n/lang/merchandiser/ru.js"),
		fr_FR: () => require("@/i18n/lang/merchandiser/fr.js")
      },
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/v2/merchandiser/index.js